<!-- delete forever confirmation pop up starts-->
@if (!universalService?.isMobileDevice) {
  <div class="modal fade" id="delete-parmanent-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': showParmanentDeleteModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          <h5>Delete Forever</h5>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="delete-confimration mt-3">
            <ul>
              <li class="text">Are you sure you want to permanently delete {{universalService?.selectedNodes.length}} item(s)?</li>
              <li class="subtext"> You cannot undo this action.</li>
            </ul>
          </div>
        </div>
        <div class="modal-footer border-top-0 p-3">
          <div class="delete-btn-main">
            <button (click)="deleteForever()">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}




@if (universalService.isMobileDevice) {
  <div class="modal fade" id="m-delete-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': showParmanentDeleteModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <div class="modal-header">
          <h6>Are you sure you want to permanently delete {{universalService?.selectedNodes.length}} item(s)?</h6>
        </div>
        <div class="modal-body">
          <div class="m-cancel-button">
            <button (click)="closePopUp()">CANCEL</button>
          </div>
          <div class="m-delete-button pt-3">
            <button (click)="deleteForever()">DELETE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- delete forever confirmation pop up ends-->